function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
import React from 'react';
export default function DotsCircleLoader(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/React.createElement("div", {
    className: "dots-circle-loader"
  });
}